// DeliveryArea.js
import React, { useEffect, useRef, useState } from "react";

import { getAddressOptions } from "../../service/api/AddressOptions/apiDeliver";
import { DeliveryAreaSheet } from "../../components/DeliveryArea";

const DeliveryArea = () => {
    const [addressOptions, setAddressOptions] = useState([]);
    useEffect(() => {
        getAddressOptions()
            .then(response => {
                if (response?.status === 200) {
                    console.log(response)
                    setAddressOptions(response.data.result);
                }
            });
    }, []);
    return (
        <>
            <div className="deliverarea container mt-4">
                <div className="card shadow p-4 border-0">
                    <h4 className="mb-3 text-primary fw-bold">運送區域</h4>
                    <div className="col-lg-12 mb-4">
                        <div className="card">
                            <DeliveryAreaSheet
                                data={addressOptions} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { DeliveryArea };
